import { Stack } from "@mui/material";
import { PageTitle } from "../components/PageTitle";
import { TITLE_ENUM, HELP_TEXT_ENUM } from "../constants/pageHeader";
import { useState } from "react";
import { IntegrationsContent } from "../components/IntergrationsContent";

export const Integrations = () => {
  const [isHelpTextOpen, setIsHelpTextOpen] = useState(false);

  return (
    <Stack>
      <PageTitle
        text={TITLE_ENUM.integrations}
        helpText={HELP_TEXT_ENUM.integrations}
        isHelpTextOpen={isHelpTextOpen}
        setIsHelpTextOpen={setIsHelpTextOpen}
      />
      <IntegrationsContent />
    </Stack>
  );
};
